import { createSelector } from "reselect";
import getFilter from "../base_getters/get_filter";

const getElementStatusFilter = createSelector([
  getFilter
], (filter) => filter.elementStatuses);

export default getElementStatusFilter
